import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MdwTabGroup } from '@spaces-ui/meadow/components/tab-group';

import { Sample } from '../../components';

@Component({
  selector: 'app-tabs',
  imports: [Sample, MdwTabGroup],
  templateUrl: './tabs.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tabs.scss',
})
export class Tabs {
  public selectedTab = 'tab1';
}
